export default __webpack_public_path__ + "static/media/icons8-umbrella-100.5f49781f.svg";